﻿/**
 * config.js
 * Runtime configuration helpers.
 */
export class Config {
  get apiBase() {
    if (typeof window === 'undefined') return 'http://localhost:3001';
    const host = window.location?.hostname || 'localhost';
    const isLocal = host === 'localhost' || host === '127.0.0.1';
    return isLocal ? `http://${host}:3001` : 'https://api.agilepro.ai';
  }

  get buildMeta() {
    return window.__BUILD_META || null;
  }
}
